const ERROR_REPORT_LINK_EXPIRY = 899999;
const access = 'access';

class ErrorReportController {
  constructor($http, config, errorReportService) {
    this.name = 'errorReport';
    this.$http = $http;
    this.config = config;
    this.errorReportService = errorReportService;
    this.downloadLink = '';
    this.setAnchorText();
    this.getSignedDownloadUrl();
    this.pollForErrorReportLink();
  }

  setAnchorText() {
    this.anchorText = this.type === access ? 'ERROR_REPORT_DOWNLOAD_LINK' : 'LOG_REPORT_DOWNLOAD_LINK';
    this.anchorText = this.batchId ? 'ERROR_REPORT' : this.anchorText;
  }

  pollForErrorReportLink() {
    this.errorReportPoll = setInterval(this.getSignedDownloadUrl.bind(this), ERROR_REPORT_LINK_EXPIRY);
  }

  getSignedDownloadUrl() {
    this.errorReportService.getErrorReportUrl(this.type, this.batchId).then(
      this.onGetSignedUrlSuccess.bind(this),
      this.onGetSignedUrlFailure.bind(this)
    );
  }

  onGetSignedUrlSuccess(response){
    this.downloadLink = response.data.content;
  }

  onGetSignedUrlFailure() {
    this.downloadLink = '#';
    clearInterval(this.errorReportPoll);
  }
}

ErrorReportController.$inject = ['config', '$http', 'errorReportService'];

export default ErrorReportController;




// WEBPACK FOOTER //
// ./app/components/errorReport/errorReport.controller.js